import { getBasename, getOrigin, joinUrlParts, stripTrailingSlash } from '../../libs/urlUtils';

export type PublicRoute = {
  pattern: () => string;
  get: (...params) => string;
};

export class AppRoutes {
  private readonly origin: string;
  private readonly basename: string;
  public primaryCategorySlug: string;

  constructor(baseURL: string) {
    this.origin = getOrigin(baseURL);
    this.basename = getBasename(baseURL);
    this.primaryCategorySlug = 'all';
  }

  public toAbsolute = (path?: string): string => joinUrlParts(this.origin, path || '');

  public isPrimaryCategoryRoute = (categorySlug: string, page?: number): boolean => {
    return categorySlug === this.primaryCategorySlug && (!page || page === 1);
  };

  public base: PublicRoute = {
    pattern: () => joinUrlParts('/', this.basename),
    get: () => joinUrlParts('/', this.basename),
  };

  public categoryRoute: PublicRoute = {
    pattern: () => joinUrlParts(this.base.pattern(), `html/:categorySlug/:page(\\d+)?`),
    get: (categorySlug: string, page?: number) => {
      return this.isPrimaryCategoryRoute(categorySlug, page)
        ? this.base.get()
        : joinUrlParts(this.base.get(), `html/${categorySlug}${page > 0 ? `/${page}` : ``}`);
    },
  };

  public subCategoryRoute: PublicRoute = {
    pattern: () => joinUrlParts(this.base.pattern(), `html/:categorySlug/:subCategorySlug/:page(\\d+)?`),
    get: (categorySlug: string, subCategorySlug: string, page?: number) =>
      `${this.categoryRoute.get(categorySlug)}/${subCategorySlug}${page > 0 ? `/${page}` : ``}`,
  };

  public searchRoute: PublicRoute = {
    pattern: () => this.base.pattern(),
    get: (query: string, page: number = 1): string => {
      page = page || 1;
      let base = stripTrailingSlash(this.base.get());
      if (base === '') {
        base = '/';
      }
      return base + `?criteria=${encodeURIComponent(query)}&page=${page}`;
    },
  };
}
